<template>
    <Modal id="payyo-payment-details-modal"
           icon="fa-solid fa-credit-card"
           :title="title">
        <div v-if="errorMessage"
             class="alert alert-danger">
            <p>{{ errorMessage }}</p>
        </div>

        <PageLoadingSpinner v-if="loading"></PageLoadingSpinner>

        <div v-if="!errorMessage && !loading"
             data-testid="payyo-payment-details-modal-body">
            <PayyoPaymentDetail :payment="payment"
                                :refunds="refunds" />
        </div>

        <template v-slot:footer>
            <div class="modl-footer">
                <SquareBtn size="lg"
                           class="cancel-btn"
                           @click="cancel">
                    {{ l('CANCEL') }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import PageLoadingSpinner from '@/vue/components/PageLoadingSpinner';
import PayyoPaymentDetail from '@/epos/vue/modals/Payment/PaymentMethods/Payyo/PayyoPaymentDetail';
import PayyoPaymentStatus from '@/lib/PaymentMethods/Payyo/Enums/PayyoPaymentStatus';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { currencyFilter } from '@/vue/filters/currencyFilter';
import { fromMinorUnit } from '@/functions/math';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'PayyoPaymentDetailsModal',

    components: {
        Modal,
        PageLoadingSpinner,
        PayyoPaymentDetail,
        SquareBtn,
    },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        title: {
            type: String,
            default: 'PAYYO_PAYMENT_DETAILS.MODAL_TITLE',
        },
        icon: {
            type: String,
            default: 'fa-rectangle-list',
        },
        payment: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            loading: true,
            errorMessage: null,
            showRefunds: false,
            refunds: null,
        };
    },

    computed: {
        PayyoPaymentStatus() {
            return PayyoPaymentStatus;
        },
    },

    created() {
        try {
            container.payyoDriver.init(false);
            // We always need tob check for refunds because they could have failed.
            container.payyoDriver.getPaymentRefunds(this.payment.id)
                .then(async (refunds) => {
                    this.refunds = refunds;
                }).catch((error) => {
                    this.errorMessage = error.message;
                })
                .finally(() => {
                    this.loading = false;
                });
        } catch (error) {
            this.errorMessage = error.message;
            this.loading = false;
        }
    },

    methods: {
        currencyFilter,
        fromMinorUnit,
    },
};
</script>
